const initState = {
    settings: [],
    error_message: null,
    settings_updated: null,

};

const settingsReducer = (state = initState, action) => {


    switch (action.type) {


        case "SETTINGS_UPDATED_RESET":
            return {
                ...state,
                settings_updated: null,
            };

        case "SETTINGS_UPDATED":
            return {
                ...state,
                settings_updated: true,
            };

        case "RESET_ERROR_MESSAGE":
            return {
                ...state,
                error_message: null,
                settings_updated: null,
            };

        case "ERROR_MESSAGE":
            return {
                ...state,
                error_message: action.error_message,
            };

      
        case "SETTINGS":
            return {
                ...state,
                settings: action.settings,
            };


        default:
            return state;
    }
};

export default settingsReducer;
